import { Injectable, signal } from '@angular/core';

/**
 * Recuerda, como singleton, si el usuario eligió explícitamente "Todos los
 * países" (pais === '') en un select de país. La elección sobrevive la
 * navegación entre Home y Vacantes: sin este estado compartido, cada vista
 * vuelve a inyectar el país detectado del navegador y descarta la elección
 * (WEB-01).
 */
@Injectable({ providedIn: 'root' })
export class FiltroPaisService {
  /** true cuando la última elección de país fue "Todos los países" (pais vacío). */
  readonly todosLosPaises = signal(false);

  /** Registra la elección de país del usuario; pais === '' marca "Todos los países". */
  registrar(pais: string): void {
    this.todosLosPaises.set(pais === '');
  }
}
